var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-checkbox",class:[_vm.theme]},[_c('input',{class:_vm.className,attrs:{"type":"checkbox","name":_vm.name,"id":_vm.id,"required":_vm.required},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.updateInput}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a578d90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Checkbox.vue
// module id = null
// module chunks = 